var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{attrs:{"value":_vm.value,"title":"Position löschen ?","ok-text":"Fortfahren","loading":_vm.loading},on:{"input":function($event){return _vm.$emit('input', $event)},"ok":_vm.submit,"cancel":_vm.cancel}},[_vm._v(" Soll die Position "),_c('b',[_vm._v(_vm._s(_vm.positionName))]),_vm._v(" wirklich gelöscht werden? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }